import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BiographyPage from './pages/BiographyPage';
import ExperiencePage from './pages/ExperiencePage';
import BlogPage from './pages/BlogPage';
import CooperationPage from './pages/CooperationPage';
import MentorPage from './pages/MentorPage';
import MentorTree from './pages/MentorTree';

const App = () => {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/biography" element={<BiographyPage />} />
        <Route path="/experience" element={<ExperiencePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/cooperation" element={<CooperationPage />} />
        <Route path="/mentor" element={<MentorPage />} />
        <Route path="/mentor/tree" element={<MentorTree />} />
      </Routes>
    </Router>
  );
};

export default App;


